import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, flashDuration: { type: Number, default: 1500 } }
  static targets = ["label", "icon"]
  static classes = ["copied"]

  async copy(event) {
    event?.preventDefault()
    const ok = await this.#writeToClipboard(this.textValue)
    this.#flash(ok ? "Copied" : "Copy failed")
  }

  async #writeToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch (err) {
        console.error("[clipboard] navigator.clipboard.writeText threw:", err)
      }
    }
    try {
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand("copy")
      document.body.removeChild(ta)
      return ok
    } catch (err) {
      console.error("[clipboard] fallback execCommand threw:", err)
      return false
    }
  }

  #flash(label) {
    if (this.hasCopiedClass) {
      this.element.classList.add(...this.copiedClasses)
    }
    if (this.hasLabelTarget) {
      this._originalLabel ??= this.labelTarget.textContent
      this.labelTarget.textContent = label
    }
    if (this.hasIconTarget) {
      this._originalIcon ??= this.iconTarget.textContent
      this.iconTarget.textContent = "✓"
    }
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.#reset(), this.flashDurationValue)
  }

  #reset() {
    if (this.hasCopiedClass) {
      this.element.classList.remove(...this.copiedClasses)
    }
    if (this.hasLabelTarget && this._originalLabel) {
      this.labelTarget.textContent = this._originalLabel
    }
    if (this.hasIconTarget && this._originalIcon) {
      this.iconTarget.textContent = this._originalIcon
    }
  }
}
